/* Office Walker 2A — FAQ disclosure rows. Sign is + closed, − open.

   One delegated listener, bound once per page. The section tag includes this
   file for every instance it renders, so binding per button attached one
   listener per instance: on a page with an even number of Q&A groups every
   click toggled the panel an even number of times and it never opened. */
(function () {
  'use strict';
  if (window.__ow2FaqBound) return;
  window.__ow2FaqBound = true;

  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var btn = el.closest('.ow2-faq__q');
    if (!btn) return;

    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));

    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = open;

    var sign = btn.querySelector('.ow2-faq__sign');
    if (sign) sign.innerHTML = open ? '+' : '−';
  });
})();
